import styled from "@emotion/styled";

export const MidSectionCardText = styled.div`
background: linear-gradient(to right, #03406C, #7E618D, #A80B45);
font-weight: 500;
line-height: 1.5;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
background-clip: text;
color: transparent;
height: 100%;
font-size: clamp(18px, 2.5vw, 24px);
`;